import { memo } from "react";
import Header from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/Header/Header";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import CreatorFragment, {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import Section from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/Section/Section";
import CreatorFragmentConfig from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragmentConfig";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";

interface TaskCreatorAndEditorSheetDetailsSectionProps {
  isLoadingCreatorFragments: boolean;
  headerTitle: string;
  creatorFragments: CreatorFragmentConfig[];
  creatorFragmentCommonProps: CreatorFragmentCommonProps;
  setCreatorFragmentRef?: (
    key: string
  ) => (element: CreatorFragmentHandle | null) => void;
}

export const TaskCreatorAndEditorSheetDetailsSection = memo(
  (props: TaskCreatorAndEditorSheetDetailsSectionProps) => {
    const {
      headerTitle,
      isLoadingCreatorFragments,
      creatorFragments,
      creatorFragmentCommonProps,
      setCreatorFragmentRef,
    } = props;

    return (
      <Section>
        <Header number="1" label={headerTitle} />
        <FixaListView id="details">
          {isLoadingCreatorFragments ? (
            <LoadingCreatorFragment />
          ) : (
            creatorFragments.map((config, index) => {
              const fragmentKey = `${config.id}-${index}`;
              return (
                <CreatorFragment
                  key={fragmentKey}
                  ref={setCreatorFragmentRef?.(fragmentKey)}
                  config={config}
                  commonProps={creatorFragmentCommonProps}
                />
              );
            })
          )}
        </FixaListView>
      </Section>
    );
  }
);
